module.exports = __webpack_public_path__ + "static/android-touch-icon-192x192-bbdc7530e4da8861859af09f9c94b3ba.png";